import { AccountInfo } from "@azure/msal-browser";
import { msalInstance } from "./msal";

/** Normalizes an email/UPN from Azure AD for MongoDB lookups (stored lowercase). */
export function normalizeAdEmail(value: string | undefined | null): string {
    if (value == null || value === "") return "";
    return String(value).trim().toLowerCase();
}

/**
 * Resolves the sign-in identifier from MSAL (claims first, then UPN) and lowercases it for comparison.
 */
export function getAdEmailFromAccount(account: AccountInfo | null | undefined): string {
    if (!account) return "";
    const claims = account.idTokenClaims as Record<string, unknown> | undefined;
    const preferred =
        typeof claims?.preferred_username === "string" ? claims.preferred_username : undefined;
    const emailClaim = typeof claims?.email === "string" ? claims.email : undefined;
    const raw = preferred ?? emailClaim ?? account.username;
    return normalizeAdEmail(raw);
}

export function getLoggedInUser(): AccountInfo | null {
    const account: AccountInfo | null = msalInstance?.getActiveAccount();
    return account;
}

export function getUserClaims(account?: AccountInfo | null): string[] {
    let userAccount = account;
    if (!userAccount) {
        userAccount = getLoggedInUser();
    }

    return userAccount?.idTokenClaims?.roles as string[] | undefined ?? [];
}

export function isUserAllowed(requiredRole: string, account?: AccountInfo | null, claims?: string[] | null): boolean {
    let userClaims = claims;

    if (!userClaims) {
        userClaims = getUserClaims(account);
    }

    return userClaims ? userClaims.includes(requiredRole) : false;
}

export function extractInitials(name: string | null | undefined): string {
    if (!name) return '';

    const ignoreList = ["ext"]; // titles to ignore

    return name
        .split(',')
        .filter(part => !ignoreList.includes(part.toLowerCase()))
        .map(part => part.trim())
        .map(part => part[0])
        .join('')
        .toUpperCase();
}